<template>
    <div>
        <p>Two step verification</p>
        <div class="errors" v-if="$validator.errors">
            <small v-for="(error, index) in $validator.errors.items" v-bind:key="index">
                {{ error.msg }}
            </small>
        </div>
        <custom-input name="2 Factor code" type="text" ref="tfaCode" v-model="tfaCode" :validationRules="{required: true}" @keyup.enter.native="validate"/>

        <div class="footer">
            <button v-if="onCancel" class="secondary" type="button" v-on:click="onCancel">{{cancelText?cancelText:'Cancel'}}</button>
            <button class="primary" type="button" v-on:click="validate">Check code</button>
        </div>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import customInput from '@/components/additional/customInput';
import { eventBus } from '@/main';

export default {
    name: 'tfaCheck',
    mixins: [
        Default
    ],
    props: [
        'onComplete',
        'onCancel',
        'cancelText'
    ],
    components: {
        customInput
    },
    inject: {
        $validator: '$validator' // Get the parent $validator instance
    },
    data() {
        return {
            tfaCode: ''
        };
    },
    mounted() {
        this.$refs.tfaCode.$el.querySelector('input').focus();
    },
    methods: {
        validate: function() {
            this.$parleyAdmin.validateMultiple([this.$refs.tfaCode], function(value) {
                if (value)
                    this.checkTfaCode();
            }.bind(this));
        },
        checkTfaCode: function() {
            // Check code through API
            this.$http.post('v1.1/auth/2fa', {
                oneTimeCode: this.tfaCode,
                authorization: this.$store.getters[this.$store.types.token.getters.get_temp].token
            }).then(response => {
                // Success callback

                // Save chat authorization header
                this.$parleyAdmin.auth.parleyChatLogin(response.data.data.authorizationHeader);

                // Emit event
                eventBus.$emit('2faComplete');

                // Redirect
                if (this.onComplete)
                    this.onComplete();
                else {
                    if (this.callback)
                        this.$router.push(this.callback); // Go to callback
                    else if (this.lastPath.fullPath)
                        this.$router.push(this.lastPath.fullPath); // Go to the last path we remembered
                    else
                        this.$router.push({name: 'accountsList'}); // Go to accountsList
                }
            }, response => {
                this.$validator.errors.clear();

                // Error callback
                let notifications = JSON.parse(response.bodyText).notifications;
                if (notifications.filter((element) => { return element.message === '2fa_not_yet_setup_for_user'; }).length > 0)
                    this.$validator.errors.add({
                        msg: 'Your 2FA has not yet been setup, please go to the following link: /2fa/setup/'
                    });
                if (notifications.filter((element) => { return element.message === 'something_went_wrong_while_inserting_token'; }).length > 0)
                    this.$validator.errors.add({
                        msg: 'Something went wrong while checking your code, please try again later'
                    });
                if (notifications.filter((element) => { return element.message === 'invalid_2fa_code'; }).length > 0)
                    this.$validator.errors.add({
                        msg: 'Code is invalid'
                    });
                if (notifications.filter((element) => { return element.message === '2fa_already_used_too_recently'; }).length > 0)
                    this.$validator.errors.add({
                        msg: 'You have already logged in recently, please wait until your authentication app provides you with a new code'
                    });
                let filter = notifications.filter((element) => { return element.message.startsWith('2fa_locked_for_'); });
                if (filter.length > 0) {
                    const time = filter[0].message.match(/_(\d*)_/)[1];
                    this.$validator.errors.add({
                        msg: 'You have been locked out for ' + time + ' seconds, because of too many failed attempts'
                    });
                }
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .custom-input {
        width: 10em;
    }

    button {
        margin: 0;
    }

    .errors {
        small {
            color: red;
        }
    }
</style>

<style lang="scss">
    .custom-input {
        input[name='2 Factor code'] {
            text-align: center;
        }
    }
</style>
